import { useSelector } from "react-redux";

export const useBlogArticleSelectors = () => {
  const { data, isError, isLoading, isDataLoaded, slug } = useSelector(
    state => state.blogArticle.content,
  );

  return { data, isError, isLoading, isDataLoaded, articleSlug: slug };
};
